module.exports = __webpack_public_path__ + "img/section1_phone@2x.3f9d73cb.png";